import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/terminal-connect')({
  component: RouteComponent,
})

function RouteComponent() {
  return <Outlet />
}
